import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap'
import { LoadingSpinner } from './../../components'
import CashMahanService from './../../services/cashMahan/CashMahanService'
import { CashMahanEmpty, CashMahanError } from './CashMahanStates'
import {
  apiErrorMessage,
  flattenSummary,
  formatMoney,
  isForbidden,
  isSuccess,
  unwrapData
} from './cashMahanUtils'

export default class CashMahanDashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: '',
      empty: false,
      data: null,
      fixerId: ''
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.load()
  }

  load() {
    this.setState({ loading: true, error: '', empty: false })
    CashMahanService.getDashboard((res) => {
      if (isForbidden(res)) {
        this.setState({ loading: false })
        this.props.history.push('/403')
        return
      }
      if (!isSuccess(res)) {
        this.setState({ loading: false, error: apiErrorMessage(res), data: null, empty: false })
        return
      }
      const data = unwrapData(res)
      const hasKeys = data && typeof data === 'object' && Object.keys(data).length > 0
      this.setState({
        loading: false,
        error: '',
        data: hasKeys ? data : null,
        empty: !hasKeys
      })
    })
  }

  openWallet() {
    const fixerId = String(this.state.fixerId || '').trim()
    if (!fixerId) {
      alert('Enter a technician / fixer ID')
      return
    }
    this.props.history.push(`/cash-mahan/technicians/${fixerId}/wallet`)
  }

  summaryValue(key) {
    const data = this.state.data || {}
    if (data[key] !== undefined && data[key] !== null) {
      return data[key]
    }
    return null
  }

  renderSummaryCard(title, value, color, onClick) {
    const rows = flattenSummary(value)
    return (
      <Col md="3" style={{ marginBottom: 16 }}>
        <Card className="text-white shadow" style={{ backgroundColor: color, cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
          <CardBody>
            <div style={{ fontSize: 13, opacity: 0.9 }}>{title}</div>
            {rows.length === 1 ? (
              <div style={{ fontSize: 26, fontWeight: 'bold', marginTop: 8 }}>
                {typeof rows[0].value === 'number' || !isNaN(Number(rows[0].value)) ? formatMoney(rows[0].value) : String(rows[0].value == null ? 'N/A' : rows[0].value)}
              </div>
            ) : (
              <div style={{ marginTop: 10 }}>
                {rows.map((row, index) => (
                  <div key={index} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
                    <span style={{ textTransform: 'capitalize' }}>{row.label}</span>
                    <strong>
                      {typeof row.value === 'object' ? formatMoney(row.value) : (isNaN(Number(row.value)) ? String(row.value == null ? 'N/A' : row.value) : formatMoney(row.value))}
                    </strong>
                  </div>
                ))}
                {!rows.length ? <div>N/A</div> : null}
              </div>
            )}
          </CardBody>
        </Card>
      </Col>
    )
  }

  render() {
    return (
      <div className="app align-items-center">
        <Container>
          <Card>
            <CardHeader className='shadow' style={{ backgroundColor: '#4dbd74', borderWidth: 0, color: '#fff' }}>
              <Row>
                <Col md="8" style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fa fa-align-justify" style={{ fontSize: 20 }}></i>
                  <strong style={{ fontSize: 20, marginLeft: 8 }}>Cash Mahan overview</strong>
                </Col>
                <Col md="4" style={{ textAlign: 'right' }}>
                  <Button className='actionsBtn' onClick={() => this.load()}>Refresh</Button>
                </Col>
              </Row>
            </CardHeader>
          </Card>

          {this.state.error ? (
            <CashMahanError message={this.state.error} onRetry={() => this.load()} />
          ) : this.state.empty ? (
            <Card>
              <CashMahanEmpty message="No Cash Mahan summary is available yet" onRetry={() => this.load()} />
            </Card>
          ) : (
            <Row>
              {this.renderSummaryCard(
                'Collected money',
                this.summaryValue('collectedMoney'),
                '#4dbd74',
                () => this.props.history.push('/cash-mahan/payment-requests')
              )}
              {this.renderSummaryCard(
                'Pending settlements',
                this.summaryValue('pendingSettlements'),
                '#f0ad4e',
                () => this.props.history.push('/cash-mahan/settlements')
              )}
              {this.renderSummaryCard(
                'Technician balances',
                this.summaryValue('technicianBalances'),
                '#20a8d8',
                null
              )}
              {this.renderSummaryCard(
                'Withdrawal activity',
                this.summaryValue('withdrawalActivity'),
                '#3a4248',
                () => this.props.history.push('/cash-mahan/withdrawals')
              )}
            </Row>
          )}

          <Card>
            <CardHeader className='shadow'>Technician wallet lookup</CardHeader>
            <CardBody className='shadow'>
              <Row>
                <Col md="4">
                  <FormGroup>
                    <Label>Fixer ID</Label>
                    <Input
                      value={this.state.fixerId}
                      onChange={(e) => this.setState({ fixerId: e.target.value })}
                      placeholder="Enter technician / fixer ID"
                      onKeyPress={(e) => { if (e.charCode === 13) this.openWallet() }}
                    />
                  </FormGroup>
                </Col>
                <Col md="3" style={{ display: 'flex', alignItems: 'flex-end' }}>
                  <Button className='actionsBtn' onClick={() => this.openWallet()}>View wallet</Button>
                </Col>
              </Row>
              <p style={{ color: '#777', marginBottom: 0 }}>
                Cash Mahan actions stay in this admin panel. Paymob keys are never stored here and Paymob is never called from the browser.
              </p>
            </CardBody>
          </Card>
          <LoadingSpinner loading={this.state.loading} />
        </Container>
      </div>
    )
  }
}
